import React, { useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import ListItemIcon from '@mui/material/ListItemIcon';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import PieChart from '../Conference/Charts/PieChart';
import { useMediaQuery, IconButton } from '@mui/material';
import { useDeadline } from '../../../contexts/DeadlineContext';

import CopyAllIcon from '@mui/icons-material/CopyAll';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';

const approve = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}>
    <FactCheckIcon />
  </Box>
);
const pending = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const reject = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))


function createData(
  ids,
  name,
  calories,
  fat,
  carbs,
  protein,

) {
  return { ids, name, calories, fat, carbs, protein };
}
const rows = [
  createData(1, 'Frozen yoghurt', "Frozen@test.com", 123456,),
]



const ConferenceCollection = () => {
  const [abstractArticle, setAbstractArticle] = React.useState([]);
  const [paidCollection, setAllPaidCollection] = React.useState([]);

  const [totalReceiptCollection, setTotalReceiptCollection] = React.useState([]);
  const [totalBankCollection, setTotalBankCollection] = React.useState([]);
  const [totalCashCollection, setTotalCashCollection] = React.useState([]);
  const [totalOnlineCollection, setTotalOnlineCollection] = React.useState([]);
  
  const [totalSARCollection, setTotalSARCollection] = React.useState([]);
  const [totalUSDCollection, setTotalUSDCollection] = React.useState([]);
  const [totalAEDCollection, setTotalAEDCollection] = React.useState([]);


  const [paindingCollection, setPaindingCollection] = React.useState([]);
  const [totalParticipantCount, setTotalParticipantCount] = React.useState([]);
  const [totalMaleParticipantCount, setTotalMaleParticipantCount] = React.useState([]);
  const [totalFemaleParticipantCount, setTotalFemaleParticipantCount] = React.useState([]);


  const eventid = localStorage.getItem('eventid');
  const role = localStorage.getItem('role');
  const eventName = localStorage.getItem('eventname');

  const history = useHistory();
  const svgRef = useRef(null);
  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';// Example gradient background
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const [copied, setCopied] = useState(false);
  const ConferenceClamCouponAppliedLink = `${window.location.origin}/#/conference/clam-coupon-event/${eventid}`;

  const conferenceRegistrationLink = `${window.location.origin}/#/conference/registration/${eventid}`;
  const ConferenceEvaluationLink = `${window.location.origin}/#/conference/evaluation-event/${eventid}`;
  const ConferenceSpeakerLink = `${window.location.origin}/#/conference/speaker/${eventid}`;
  const ConferenceAttendanceLink = `${window.location.origin}/#/conference/attendance/${eventid}`;
  const ConferenceLoginLink = `${window.location.origin}/#/conference/participant-login/${eventid}`;
  const handleCopy = (linkToCopy) => {
    navigator.clipboard.writeText(linkToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  useEffect(() => {
    axios.get(`api/get-conference-collection?id=${eventid}`).then(res => {
      if (res.status === 200) {

        const normal = res.data.normal || {};
        const byCurrency = res.data.totalByCurrency || {};

        setTotalReceiptCollection(normal.receipt || 0);  // <-- use "receipt" not "totalReceipt"
        setTotalBankCollection(normal.bank || 0);        // <-- "bank"
        setTotalCashCollection(normal.cash || 0);        // <-- "cash"
        setTotalOnlineCollection(normal.online || 0);    // <-- "online"

        setTotalSARCollection(byCurrency.SAR || 0);          // <-- "sar"
        setTotalUSDCollection(byCurrency.USD || 0);          // <-- "usd"
        setTotalAEDCollection(byCurrency.AED || 0);          // <-- "aed"


      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    })
  }, []);
  useEffect(() => {
    axios.get(`api/get-conference-participnat-count?id=${eventid}`).then(res => {
      if (res.status === 200) {

        const totalParticipants = res.data.totalNormalParticipants;
        const maleParticipants = res.data.maleNormalParticipants;
        const femaleParticipants = res.data.femaleNormalParticipants;

        // Keeping the existing state names
        setTotalParticipantCount(totalParticipants);
        setTotalMaleParticipantCount(maleParticipants);
        setTotalFemaleParticipantCount(femaleParticipants);

      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    });
  }, [eventid]);


  const downloadQRCode = (elementId, filename) => {
    const qrCodeURL = document.getElementById(elementId).toDataURL("image/png").replace("image/png", "image/octet-stream");
    const aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = filename;
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  // Download Barcode as image



  const downloadBarcode = (filename) => {
    if (svgRef.current) {
      // Get the SVG content from the ref
      const svg = svgRef.current.outerHTML;

      // Create a Blob for SVG content
      const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });

      // Create a link to download the Blob as an SVG file
      const url = URL.createObjectURL(blob);

      const aEl = document.createElement('a');
      aEl.href = url;
      aEl.download = filename;

      // Trigger the download
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);

      // Clean up the object URL after the download
      URL.revokeObjectURL(url);
    } else {
      console.error('SVG reference not found.');
    }
  };

  return (
    <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
      <Grid container spacing={isSmallScreen ? 2 : 4}>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
          <Button sx={{
            float: 'right',
            marginTop: '0%',
            background: abstractHomeSetup.color_code_two || gradientBackground,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'

            onClick={() => history.goBack()} >
            Back
          </Button>
          <Item>
            <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
              Conference Collection Dashboard
            </Typography>

          </Item>
        </Grid>
        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Male Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color='secondary' key={1}>
                      {pending}. {totalMaleParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Female Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color="error.main" key={1}>
                      {pending}. {totalFemaleParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Bank Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalBankCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Receipt Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalReceiptCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Cash Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalCashCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                    Total Online Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalOnlineCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              
              {/* <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      SAR Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalSARCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid> */}
             
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      AED Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalAEDCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>

               <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      USD Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalUSDCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              
            </Grid>
          </Item>
        </Grid>

      </Grid>

      {/* QR Code Section */}
      <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Registration Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Registration page:{' '}
              <strong>{conferenceRegistrationLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(conferenceRegistrationLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>

          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Registration QRCode
                  </Typography>
                  <QRCode
                    id="affilifitonConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={conferenceRegistrationLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('affilifitonConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Registration QRCode</Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={conferenceRegistrationLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_barcode.svg')}
                  >
                    Download Barcode
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>











      <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Clam Coupon Applied Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Registration page:{' '}
              <strong>{ConferenceClamCouponAppliedLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(ConferenceClamCouponAppliedLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>

          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Registration QRCode
                  </Typography>
                  <QRCode
                    id="affilifitonConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={conferenceRegistrationLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('affilifitonConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Registration QRCode</Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={conferenceRegistrationLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_barcode.svg')}
                  >
                    Download Barcode
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>

      <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Evaluation Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Evaluation  page:{' '}
              <strong>{ConferenceEvaluationLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(ConferenceEvaluationLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>

          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Evaluation
                  </Typography>
                  <QRCode
                    id="EvaluationConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={ConferenceEvaluationLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('EvaluationConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Evaluation </Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={ConferenceEvaluationLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_barcode.svg')}
                  >
                    Conference Evaluation
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>


        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Speaker Registration Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Speaker Registration From:{' '}
              <strong>{ConferenceSpeakerLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(ConferenceSpeakerLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>

          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Speaker QRCode
                  </Typography>
                  <QRCode
                    id="EvaluationConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={ConferenceSpeakerLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('EvaluationConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Evaluation </Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={ConferenceSpeakerLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_barcode.svg')}
                  >
                    Conference Speaker Barcode
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>





      {/* Conference Attendance */}
       <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Attendance Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Attendance :{' '} 
              <strong>{ConferenceAttendanceLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(ConferenceAttendanceLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>

          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Attendance QRCode
                  </Typography>
                  <QRCode
                    id="AttendanceConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={ConferenceAttendanceLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('AttendanceConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Attendance </Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={ConferenceAttendanceLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_attendance.svg')}
                  >
                    Conference Attendance Barcode
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>

{/* Participant Login Link */}
   
   <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
                    
        <Item>
          <Typography variant="h6" gutterBottom>
            Conference Participant Login Link
          </Typography>
          {eventid && (
            <Typography variant="body1">
              Link to Conference Participant Login page:{' '}
              <strong>{ConferenceLoginLink}</strong>{' '}
              <IconButton onClick={() => handleCopy(ConferenceLoginLink)} title="Copy link">
                <CopyAllIcon />
              </IconButton>
              {copied && (
                <Typography variant="body2" color="success.main" sx={{ marginLeft: 1 }}>
                  Copied!
                </Typography>
              )}
            </Typography>
          )}
        </Item>

        <Item>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Conference Participant Login QRCode
                  </Typography>
                  <QRCode
                    id="ParticipantLoginConferenceqrCodeEl"
                    size={isSmallScreen ? 100 : 150}
                    value={ConferenceLoginLink}
                    style={{ marginTop: '12px' }} // adds space between title and QRCode
                  />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '2%',
                      ":hover": { color: "white" },
                      fontSize: isSmallScreen ? '12px' : '14px',
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color="success"
                    size="small"
                    variant="contained"
                    onClick={() => downloadQRCode('ParticipantLoginConferenceqrCodeEl', `${eventName}_QRCode.png`)}
                  >   
                    Download
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <Typography variant="h6">Conference Participant Login </Typography>
                  <Barcode ref={svgRef} format="CODE128" width={1} value={ConferenceLoginLink} />
                </CardContent>
                <CardActions>
                  <Button
                    sx={{
                      marginTop: '5%', ":hover": { color: "white" },
                      background: abstractHomeSetup.color_code_two || gradientBackground,
                    }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => downloadBarcode('conference_participant_login.svg')}
                  >
                    Conference Participant Login Barcode
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Item>
      </Grid>


      <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <PieChart
                    totalParticipantCount={totalParticipantCount}
                    totalMaleParticipantCount={totalMaleParticipantCount}
                    totalFemaleParticipantCount={totalFemaleParticipantCount}
                  />
                </CardContent>
                <CardActions>
                  <Button size="small" component={Link} to="#">
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>


          </Grid>
        </Item>
      </Grid>
      <hr></hr>
    </Box>
  );
}



export default ConferenceCollection;
